import { jsx as _jsx } from "react/jsx-runtime";
import { __ } from "@jti/fe-common";
import { Button } from "@jti/ui";
import styles from "./PricesFooter.module.scss";
const PricesFooter = ({ disabled, onCheckout }) => {
    return (_jsx("div", { className: styles.container, children: _jsx(Button, { onClick: onCheckout, color: "primary", disabled: disabled, className: styles.btn, "data-testid": "loginCheckoutButton", children: __("cart.button.checkout") }) }));
};
export default PricesFooter;
//# sourceMappingURL=index.js.map